/** Public @username for display; falls back to a short uid prefix when unset. */
export function displayHandle(handle: string | undefined, userId: string): string {
  const trimmed = handle?.trim();
  return trimmed || userId.slice(0, 8);
}

/** True when the user has permanently chosen their @username. */
export function isHandleLocked(profile: { handle?: string; handleChosen?: boolean } | null | undefined): boolean {
  if (!profile) return false;
  if (profile.handleChosen) return true;
  return false;
}
